export const getPriceAlerts = state => state.priceAlerts.data;
export const getPriceAlertsLoading = state => state.priceAlerts.loading;
